export type DeviceNameWithoutDefault = 'md' | 'lg';
export type DefaultDeviceName = 'sm';
export type DeviceName = DeviceNameWithoutDefault | DefaultDeviceName;

export const deviceNames: DeviceName[] = ['sm', 'md', 'lg'];

export function getCurrentDevice(): DeviceName | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  if (window.matchMedia('(min-width: 1024px)').matches) {
    return 'lg';
  } else if (window.matchMedia('(min-width: 768px)').matches) {
    return 'md';
  }
  return 'sm';
}
